<script lang="ts">
	import { _ } from 'utils/i18/i18n';

	export let dark = false;
	export let stats;
</script>

<ul class="stat-list" class:dark>
	{#each Object.entries(stats) as [name, value]}
		<li class="stat-list-item">
			<p class="description">{$_(`exchange.stats.${name}`)}</p>
			<p class="value">{value}</p>
		</li>
	{/each}
</ul>

<style lang="scss">
	@import './exchangeStats.scss';
</style>
